import {useState, useEffect} from "react";
import {useParams, Link} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

// С9 — контролна справка на землище (Г3 §5).
export const ReportControl = () => {
    const {year, settlement_ekatte} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    useEffect(() => {
        request.get(`${baseUrl()}/reports/control/${year}/${settlement_ekatte}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, settlement_ekatte]);

    const handlePdf = () => {
        downloadPdf(`/reports/control/${year}/${settlement_ekatte}?format=pdf`, `S9_${settlement_ekatte}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const s = data.settlement;
    const t = data.totals;
    const to = data.totals_over;
    // Ц5: огледалният ред на „над-изчертали" — оставащото за чертане.
    const tl = data.totals_left;
    const fmt = v => Number(v).toFixed(1);

    // Е18: тоталните редове (ред на колоните: Правно, Годна, Изчертано, Налично).
    const totalsRows = () => (
        <>
            <tr className="fw-bold">
                <td>ОБЩО</td>
                <td></td>
                <td className="text-end">{fmt(t.pravno)}</td>
                <td className="text-end">{fmt(t.suitable_land)}</td>
                <td className="text-end">{fmt(t.drawn)}</td>
                <td className="text-end">{fmt(t.available)}</td>
            </tr>
            {to.count > 0 && (
                <tr className="fw-bold text-danger">
                    <td>в т.ч. над-изчертали ({to.count})</td>
                    <td></td>
                    <td className="text-end">{fmt(to.pravno)}</td>
                    <td className="text-end">{fmt(to.suitable_land)}</td>
                    <td className="text-end">{fmt(to.drawn)}</td>
                    <td className="text-end">{fmt(to.available)}</td>
                </tr>
            )}
            {/* Ц5: колко ОСТАВА за чертане, събрано от ползвателите с налично.
                При равнено землище (Σ правно == Σ изчертано) зеленото и
                червеното число са еднакви по големина и с обратен знак. */}
            {tl && tl.count > 0 && (
                <tr className="fw-bold text-success">
                    <td>в т.ч. с налично за чертане ({tl.count})</td>
                    <td></td>
                    <td className="text-end">{fmt(tl.pravno)}</td>
                    <td className="text-end">{fmt(tl.suitable_land)}</td>
                    <td className="text-end">{fmt(tl.drawn)}</td>
                    <td className="text-end">{fmt(tl.available)}</td>
                </tr>
            )}
        </>
    );

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С9 — Контролна справка на землище</h5>
                    <div>{s.settlement}, община {s.municipality}, област {s.region} | ЕКАТТЕ: {s.ekatte}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            <div className="table-responsive">
                <table className="table table-sm table-bordered">
                    <thead className="tableHead">
                    {/* Е18: тоталите и НАЙ-ОТГОРЕ (над шапката), остават и долу. */}
                    {totalsRows()}
                    <tr>
                        <th>Ползвател</th>
                        <th>Булстат</th>
                        <th className="text-end">Правно</th>
                        <th className="text-end">Годна</th>
                        <th className="text-end">Изчертано</th>
                        <th className="text-end">Налично</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.rows.map((row, i) => (
                        <tr key={i} className={row.available < 0 ? "table-danger" : undefined}>
                            <td>
                                <Link to={`/info/${year}/${settlement_ekatte}/${row.bullstat}`}
                                      style={{textDecoration: "none", color: "var(--app-gold)"}}>
                                    {row.company_name}
                                </Link>
                            </td>
                            <td>{row.bullstat}</td>
                            <td className="text-end">{fmt(row.pravno)}</td>
                            <td className="text-end">{fmt(row.suitable_land)}</td>
                            <td className="text-end">{fmt(row.drawn)}</td>
                            <td className="text-end">{fmt(row.available)}</td>
                        </tr>
                    ))}
                    </tbody>
                    <tfoot>
                    {totalsRows()}
                    </tfoot>
                </table>
            </div>

            <div className="fw-bold mt-2" style={{color: "var(--app-gold)"}}>
                Равнение: Σ правно ({fmt(t.pravno)}) = Σ изчертано ({fmt(t.drawn)}) + Σ налично ({fmt(t.available)})
            </div>
            {tl && tl.count > 0 && to.count > 0 && (
                <div className="text-muted mt-1" style={{fontSize: "0.9rem"}}>
                    Зеленото ({fmt(tl.available)}) и червеното ({fmt(to.available)}) се очаква
                    да са еднакви по големина и с обратен знак — сборът им е общото налично
                    ({fmt(t.available)}).
                </div>
            )}
        </div>
    );
};
